// Icons
import {
  FaWhatsapp,
  FaInstagram,
  FaTiktok,
  FaBriefcase,
  FaGoogle,
} from 'react-icons/fa';
// Constants
import {
  INSTAGRAM_URL,
  TIKTOK_URL,
  UPWORK_URL,
  GOOGLE_URL,
} from '../../utils/Constants';

export const socialMediaLinks = [
  {
    serviceName: 'Instagram',
    icon: <FaInstagram size={24} />,
    url: INSTAGRAM_URL,
    ariaLabel: 'Open Instagram profile in a new tab',
    title: 'Instagram',
  },
  // {
  //   serviceName: 'WhatsApp',
  //   icon: <FaWhatsapp size={24} />,
  //   url: `https://wa.me/${String(CompanyWhatsappNumber).replace(/\D/g, '')}`,
  //   ariaLabel: 'Open WhatsApp chat in a new tab',
  //   title: 'WhatsApp',
  // },
  {
    serviceName: 'Google',
    icon: <FaGoogle size={24} />,
    url: GOOGLE_URL,
    ariaLabel: 'Open Google profile in a new tab',
    title: 'Google',
  },
  {
    serviceName: 'TikTok',
    icon: <FaTiktok size={24} />,
    url: TIKTOK_URL,
    ariaLabel: 'Open TikTok profile in a new tab',
    title: 'TikTok',
  },
  {
    serviceName: 'Upwork',
    icon: <FaBriefcase size={24} />,
    url: UPWORK_URL,
    ariaLabel: 'Open Upwork profile in a new tab',
    title: 'Upwork',
  },
];
